import { action, makeObservable, observable } from "mobx";
import FilterSelectStore from "../../../pages/MainPage/FilterSelectStore";

class SelectorStore<T> extends FilterSelectStore<T> {
  isDropdownRevealed: boolean;

  constructor(selectedOption: T) {
    super(selectedOption); // Вызов конструктора базового класса
    makeObservable(this, {
      isDropdownRevealed: observable,
      setDropdownRevealStatus: action,
    });
    this.isDropdownRevealed = false;
  }

  setDropdownRevealStatus(status: boolean): void {
    this.isDropdownRevealed = status;
  }
}

export default SelectorStore;
